export const environment = {
    production: true,
    recaptchaSiteKey: '6LfAKbcsAAAAABhYWqcxnb-YtOCeIfhC44yH0rFx',
    firebase : {
        apiKey: "AIzaSyB-pYv_EnYUlOjJj4dEJwFYWsjccV1yrFo",
        authDomain: "articix-website.firebaseapp.com",
        projectId: "articix-website",
        storageBucket: "articix-website.appspot.com",
        messagingSenderId: "841390875475",
        appId: "1:841390875475:web:a6229aaf1ab039a9f977a6",
        measurementId: "G-W5QQ94CW28"
    }
};
